import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681bf0bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "添加名单", -1))
const _hoisted_4 = { class: "drawer_content" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_name" }, "观众姓名：", -1))
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_name" }, "用户账号：", -1))
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_name" }, "分区：", -1))
const _hoisted_11 = { class: "drawer_footer" }
const _hoisted_12 = { class: "btn_group" }

import { ref } from 'vue';
import http from '@/api';
import { message } from 'ant-design-vue';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddFullList',
  props: {
    dataSource: null
  },
  emits: ['click:callAddPage'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };


const onBlack = () => {
  emit('click:callAddPage');
};
const studioId = router.currentRoute.value.params.studioId;

const from = ref({
  name: '',
  mobile: '',
  area: '',
});

const createMember = () => {
  const data = {
    studio_id: studioId,
    realname: from.value.name,
    mobile: from.value.mobile,
    area: from.value.area,
  };
  if (props.dataSource.drawType == 2) {
    // 活动抽奖
    data.draw_new_id = props.dataSource.drawId;
    http.lottery
      .createMemberNew(data)
      .then((res) => {
        onBlack();
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else {
    http.lottery
      .createMember(data)
      .then((res) => {
        onBlack();
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_button, {
        type: "link",
        class: "drawer_title_back",
        onClick: onBlack
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回>>")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_a_input, {
          value: from.value.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((from.value.name) = $event)),
          placeholder: "请输入观众名字",
          class: "in_group"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_a_input, {
          value: from.value.mobile,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((from.value.mobile) = $event)),
          placeholder: "请输入用户账号",
          class: "in_group"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_a_input, {
          value: from.value.area,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((from.value.area) = $event)),
          placeholder: "请输入分区",
          class: "in_group"
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          onClick: createMember
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})